import React, { useState, useEffect } from 'react'
import { IconMaps } from '@ow/icons'
import { Tooltip } from '@ow/comps'
import { Loader } from '@mantine/core'
import { StyledOtherArticle, StyledOtherArticleList } from './styled/article'
import InlineRenders from '../renders/inline-renders'
import useArticle from './hooks/article'

const RenderAccountTypeIcon = function ({ isPublic }) {
  return (
    <IconMaps
      width={16}
      height={16}
      size={16}
      type={isPublic ? 'authPublicIcon' : 'authPrivateIcon'}
    />
  )
}

const Content = function ({
  articleConfig,
  username,
  tbId,
  tbFields,
  fetchRemoteData,
}) {
  const {
    titleSlug_side,
    createBySlug_side,
    bottomField_side = [],
    sortSlug_side,
    accountTypeSlug_side,
    toThousands,
  } = useArticle(articleConfig)

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (username) {
      setLoading(true)
      const article = fetchRemoteData(tbId)
      article
        .fetchTbData({
          filters: {
            queries: [
              {
                slug: 'username',
                queryType: 'equal',
                value: username,
              },
            ],
            logicType: 'and',
          },
          sorts: [{ slug: sortSlug_side, order: 'desc' }],
        })
        .then((res) => {
          setLoading(false)
          setData(res.slice(0, 5))
        })
    }
  }, [username])

  return (
    <StyledOtherArticle className="h-full flex flex-col">
      <div className="other-article-header">
        <span className="other-article-title">其他文章</span>
      </div>
      {loading && (
        <div className="flex justify-center py-5">
          <Loader />
        </div>
      )}
      {!loading && (
        <StyledOtherArticleList className="flex-1 overflow-auto">
          {data.map((item) => {
            return (
              <div className="other-article-list-item">
                <InlineRenders
                  className="article-title"
                  value={item[titleSlug_side]}
                  fields={tbFields}
                  defs={tbFields.find((v) => v.slug === titleSlug_side)}
                />
                <div className="flex items-center">
                  <InlineRenders
                    className="article-author"
                    value={item[createBySlug_side]}
                    fields={tbFields}
                    defs={tbFields.find((v) => v.slug === createBySlug_side)}
                  />
                  {accountTypeSlug_side && (
                    <Tooltip
                      trigger={
                        <span>
                          <RenderAccountTypeIcon
                            isPublic={item[accountTypeSlug_side]}
                          />
                        </span>
                      }
                      position="bottom"
                      on={['hover']}
                      arrow="top"
                      style={{
                        background: 'white',
                        color: 'rgba(0,0,0,.9)',
                        width: 'auto',
                        opacity: 1,
                        padding: '4px 14px 4px 6px',
                        boxShadow:
                          '0 5px 5px -3px rgba(0,0,0,0.10), 0 -8px 10px 1px rgba(0,0,0,0.06), 0 3px 14px 2px rgba(0,0,0,0.05)',
                      }}
                      arrowStyle={{ color: 'white' }}
                    >
                      <span className="flex items-center">
                        <RenderAccountTypeIcon
                          isPublic={item[accountTypeSlug_side]}
                        />
                        <span>
                          {item[accountTypeSlug_side] ? '官方账号' : '私人账号'}
                        </span>
                      </span>
                    </Tooltip>
                  )}
                </div>
                <div className="flex items-center bottom-info">
                  {bottomField_side.map((field) => {
                    return (
                      <div className="flex items-center">
                        {field.icon && (
                          <div>
                            <IconMaps
                              width={16}
                              height={16}
                              type={field.icon}
                              fill={field.iconFill}
                            />
                          </div>
                        )}
                        <InlineRenders
                          className="number"
                          value={toThousands(item[field.slug])}
                          fields={tbFields}
                          defs={tbFields.find((v) => v.slug === field.slug)}
                        />
                        {field.showTitle && (
                          <span className="text">{field.title}</span>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </StyledOtherArticleList>
      )}
    </StyledOtherArticle>
  )
}

export default Content
